module.exports = __webpack_public_path__ + "img/tmf-castle.d0488a72.png";